import Util from '@/helper/Utility.js';
import BzbsAuth from "@/core/Account/service/BzbsAuth.js";
import { AccountModel } from '@/core/Account/model/AccountModel';

/**
 * Token
 * @method getToken
 * @method getTokenShuffle
 *
 * Cache
 * @method getCacheUser
 * @method getUserLevel
 * @method getUserLevelDetail
 * @method getUserFlag
 * @method getCachePoint
 * @method getCachePointUpdateDate
 * @method removeCacheUser
 * @method updatePoint
 *
 * Login
 * @method setLogout
 * @method loginStatus
 * @method isLogin
 *
 * Api login
 * @method apiLogout
 */

export default {
    //#region user
    /**
     * Get user token.
     * @return {string|null} user token.
     */
    getToken: function () {
        let account = this.getCacheUser();
        return account != null ? account.token : null;
    },
    /**
     * Get shuffled user's token.
     * @return {string|null} user token.
     */
    getTokenShuffle: function () {
        let token = this.getToken();
        return Util.shuffleToken(token);
    },

    /**
     * Get cache user.
     * @return {object} Cache user.
     */
    getCacheUser: function () {
        let account = new AccountModel();
        return account.loadCache();
    },

    getUserLevel: function () {
        let user = this.getCacheUser();
        if (user != null) {
            return user.userLevel;
        }
        return 0;
    },
    getUserLevelDetail: function () {
        let user = this.getCacheUser();
        if (user != null) {
            return user.userLevelDetail;
        }
        return '0';
    },
    getUserFlag: function () {
        let user = this.getCacheUser();
        if (user != null) {
            return user.userFlags;
        }
        return [];
    },

    /**
     * Get point.
     * @return {number} User point.
     */
    getCachePoint: function () {
        if (this.isLogin()) {
            let user = this.getCacheUser();
            if (user != null) {
                return user.point.point;
            }
        }

        return 0;
    },
    /**
     * Get user's point last update date.
     * @return {number} User's point date.
     */
    getCachePointUpdateDate: function () {
        if (this.isLogin()) {
            let user = this.getCacheUser();
            if (user != null) {
                return user.point.time;
            }
        }

        return 0;
    },
    /**
     * Remove cache user.
     */
    removeCacheUser: function () {
        let account = new AccountModel();
        account.removeCache();
    },

    /**
     * Set user logout.
     * @return {promises} Logout response.
     */
    setLogout: function () {
        let token = this.getToken();
        this.removeCacheUser();

        return this.apiLogout(token);
    },

    /**
     * Update point.
     * @param {object} point
     */
    updatePoint: function (point) {
        let user = this.getCacheUser();
        user.point = point;
        user.saveCache();
    },

    /**
     * Check login.
     * @return {boolean} Login status.
     */
    isLogin: function() {
        let token = this.getToken();
        return !Util.isEmptyStr(token);
    },

    /**
     * Logout.
     */
    apiLogout: function (token) {
        return new Promise((resolve, reject) => {
            if (!token) {
                resolve(null);
            } else {
                BzbsAuth.apiLogout(token, null, null).subscribe({
                    next: (data) => {
                        resolve(data);
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
            }
        });
    },
    //#endregion user
 
    getCacheUserCookie: function () {
        let account = new AccountModel(); 
        return account.loadCacheCookie();
    }, 
    
    getCacheErrorUserLoginCookie: function () {
        let account = new AccountModel(); 
        return account.loadCacheErrorUserLoginCookie();
    }, 
     
}
